var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"test"}},[(_vm.hasData)?_c('div',{attrs:{"id":"demo"}}):_c('div',{staticClass:"block-none"},[_c('img',{staticClass:"img-none",attrs:{"src":require("@/assets/images/train/img_none.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"block-none-txt"},[_vm._v("暂无数据")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3433a029","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AIFV/pdfView.vue
// module id = null
// module chunks = 